/**
 * AGEON Landing — premium marketing page (reference-inspired).
 */
import { useEffect } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';
import { useAuth } from '../store/auth';
import { homePathForUser, usesAdminWorkspace } from '../utils/workspace';

import LandingHeader from './landing/LandingHeader';
import LandingHeroPremium from './landing/LandingHeroPremium';
import LandingAchieversSection from './landing/LandingAchieversSection';
import LandingFounderNote from './landing/LandingFounderNote';
import LandingPlatform from './landing/LandingPlatform';
import LandingCoreProblem from './landing/LandingCoreProblem';
import LandingCategoryShift from './landing/LandingCategoryShift';
import LandingCompetitorReality from './landing/LandingCompetitorReality';
import LandingWhatAgeonIs from './landing/LandingWhatAgeonIs';
import LandingAgeonDifference from './landing/LandingAgeonDifference';
import LandingInvestorSections from './landing/LandingInvestorSections';
import LandingLeadership from './landing/LandingLeadership';
import LandingStats from './landing/LandingStats';
import LandingQuote from './landing/LandingQuote';
import LandingEbg from './landing/LandingEbg';
import LandingMotivation from './landing/LandingMotivation';
import LandingFranchises from './landing/LandingFranchises';
import LandingCta from './landing/LandingCta';
import LandingFooter from './landing/LandingFooter';

export default function Landing() {
    const user = useAuth(s => s.user);
    const isAdminish = usesAdminWorkspace(user);
    const dashHref = homePathForUser(user);

    useEffect(() => {
        AOS.init({
            duration: 800,
            once: true,
            offset: 56,
            easing: 'ease-out-cubic',
            disable:
                typeof window !== 'undefined' &&
                window.matchMedia('(prefers-reduced-motion: reduce)').matches,
        });
        const t1 = window.setTimeout(() => AOS.refresh(), 400);
        const t2 = window.setTimeout(() => AOS.refresh(), 1800);
        const onResize = () => AOS.refresh();
        window.addEventListener('resize', onResize);
        return () => {
            window.clearTimeout(t1);
            window.clearTimeout(t2);
            window.removeEventListener('resize', onResize);
        };
    }, []);

    useEffect(() => {
        document.documentElement.classList.add('scroll-smooth');
        return () => document.documentElement.classList.remove('scroll-smooth');
    }, []);

    return (
        <div className="min-h-screen bg-white text-brand-dark font-sans antialiased">
            <LandingHeader />

            <main>
                <LandingPlatform />

                {/* <LandingHeroPremium dashHref={dashHref} /> */}
                <LandingAchieversSection />
                <LandingFounderNote />
                <LandingLeadership />
                <LandingFranchises />
                <LandingEbg />
                {/* <LandingCoreProblem /> */}
                <LandingCategoryShift />
                <LandingCompetitorReality />
                <LandingWhatAgeonIs />
                <LandingAgeonDifference />
                <LandingInvestorSections />
                
                {/* <LandingStats /> */}
                {/* <LandingQuote /> */}

                <LandingMotivation />
                {/* <LandingCta dashHref={dashHref} isAdminish={isAdminish} /> */}
            </main>

            <LandingFooter dashHref={dashHref} />
        </div>
    );
}
